import { ThemeOptions, ThemeProvider as MuiThemeProvider, createTheme, CssBaseline, Theme } from "@mui/material";
import { CompanyType } from "./Enums/CompanyType";
import { pkpTheme, kpasPkpTheme } from "vig-ui-library";

export type ThemeProviderProps = {
    children: React.ReactNode;
    companyType: CompanyType;
    themeOverride?: ThemeOptions;
}

export const ThemeProvider = (props: ThemeProviderProps) => {
    const defaultTheme = props.companyType === CompanyType.KOMUNALNA ? kpasPkpTheme : pkpTheme;
    const theme = (props.themeOverride ? createTheme(props.themeOverride, defaultTheme) : defaultTheme) as unknown as Theme;

    return <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {props.children}
    </MuiThemeProvider>
};